import React from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { motion } from 'framer-motion';
import { XCircle, ArrowLeft, MessageCircle } from 'lucide-react';

const BookingCancelled = () => {
  const [searchParams] = useSearchParams();
  const bookingId = searchParams.get('booking_id');

  return (
    <div className="min-h-screen bg-[#0A0A0A] flex items-center justify-center px-4 py-20">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="max-w-md w-full text-center"
      >
        {/* Icon */}
        <motion.div
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ type: "spring", delay: 0.2 }}
          className="w-24 h-24 bg-[#2A2A2A] rounded-full flex items-center justify-center mx-auto mb-6"
        >
          <XCircle className="w-12 h-12 text-gray-400" />
        </motion.div>

        <h1 className="font-heading text-3xl md:text-4xl font-bold text-white mb-4">
          Pagamento Annullato
        </h1>
        <p className="text-gray-400 mb-8">
          Il pagamento è stato annullato. La tua prenotazione non è stata confermata e non ti è stato addebitato nulla.
        </p>

        {/* Info Box */}
        <div className="bg-[#141414] border border-[#2A2A2A] p-6 mb-8 text-left">
          <h3 className="text-white font-semibold mb-3">Cosa è successo?</h3>
          <p className="text-gray-400 text-sm mb-4">
            Hai annullato il processo di pagamento prima di completarlo. Se hai riscontrato problemi, contattaci e saremo felici di aiutarti.
          </p>
          <h3 className="text-white font-semibold mb-3">Vuoi riprovare?</h3>
          <p className="text-gray-400 text-sm">
            Puoi tornare alla home e iniziare una nuova prenotazione. Le disponibilità potrebbero variare.
          </p>
        </div>

        {/* Actions */}
        <div className="flex flex-col gap-4">
          <Link
            to="/"
            className="flex items-center justify-center gap-2 bg-[#FFCC00] text-[#0A0A0A] font-bold uppercase tracking-wide hover:bg-[#E6B800] px-8 py-4 transition-all"
          >
            <ArrowLeft className="w-5 h-5" />
            Torna alla Home
          </Link>
          <a
            href="https://wa.me/393773781602?text=Ciao, ho avuto problemi con la prenotazione"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center justify-center gap-2 border border-[#2A2A2A] hover:border-[#25D366] text-white hover:text-[#25D366] px-8 py-4 transition-all"
          >
            <MessageCircle className="w-5 h-5" />
            Hai bisogno di aiuto?
          </a>
        </div>
      </motion.div>
    </div>
  );
};

export default BookingCancelled;
